<template>
    <div class="main">
        <div class="cbanner">
            <img src="../../../assets/images/banner_contact.jpg" />
            <div class="btext">
                <h3>政策法规</h3>
                <p>以客户为本，真诚服务，持续创新，追求卓越</p>
            </div>
        </div><!-- channel banner END-->
        <div class="main_inner">

            <el-breadcrumb separator-class="el-icon-arrow-right">
                <span class="btitle">当前位置：</span>
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>政策法规</el-breadcrumb-item>
                <el-breadcrumb-item>政策法规</el-breadcrumb-item>
            </el-breadcrumb>

            <el-row>
                <el-col :span="5" class="leftside">
                    <el-menu
                            default-active="1"
                            class="el-menu-vertical-demo"
                         >
                        <router-link :to="{path:'/policiesRegulations'}">
                            <el-menu-item index="1"><span slot="title">政策法规</span></el-menu-item>
                        </router-link>
                        <router-link :to="{path:'borrowingKnowledge'}">
                            <el-menu-item index="2"><span slot="title">借贷知识</span></el-menu-item>
                        </router-link>
                    </el-menu>
                </el-col>
                <el-col :span="19">
                    <div class="con_right">
                        <ul class="list_news" >
                            <li v-for="item in policiesRegulationsArray"><span>{{item.publishTime|date_from_unix_YearMonthDay}}</span><a v-on:click="toPoliciesRegulationsDetail(item)">{{item.title}}</a></li>
                        </ul>
                        <el-pagination
                                background
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :page-size="pageSize"
                                layout="prev, pager, next"
                                :total="total">
                        </el-pagination>
                    </div>
                </el-col>
            </el-row>
        </div><!-- main intro END -->
    </div>
</template>
<script>
    import {reqPoliciesRegulations} from "../../../api/contentManagement-api";

    export  default {
        data(){
            return{
                total:0,
                pageNum:1,
                pageSize:10,
                policiesRegulationsArray:[],
            }
        },
        methods:{
            handleCurrentChange(val) {
                this.pageNum = val;
                this.getPoliciesRegulations();
            },
            handleSizeChange(val) {
                this.pageSize=val;
                this.getPoliciesRegulations();
            },
            getPoliciesRegulations(){
                reqPoliciesRegulations({pageNum: this.pageNum, pageSize: this.pageSize}).then((res)=>{
                    if(res.data.code===1){
                        this.total=res.data.data.total;
                        this.policiesRegulationsArray=res.data.data.list;
                    }else {
                        this.policiesRegulationsArray=[{title:'抱歉，暂无数据'}];
                    }
                })
            },
            toPoliciesRegulationsDetail(item){
                this.$router.push({path:'policiesRegulationsDetail',query:{id:item.id,total:this.total}});
            },

        },
        mounted(){
            this.$store.dispatch('showHF');
            this.getPoliciesRegulations();
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/contentManagement/policiesRegulations/PoliciesRegulations.vue